import { useState } from "react";
import { Box } from "@mui/material";
import { useSwipeable } from "react-swipeable";

export default function SwipeableStudentRow({ children, deleteButton }) {
  const [open, setOpen] = useState(false);

  const handlers = useSwipeable({
    onSwipedLeft: () => setOpen(true),
    onSwipedRight: () => setOpen(false),
    trackMouse: false,
    preventScrollOnSwipe: true,
  });

  return (
    <Box
      sx={{
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* DELETE AREA */}
      <Box
        sx={{
          position: "absolute",
          right: 0,
          top: 0,
          bottom: 0,
          width: 70,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {deleteButton}
      </Box>

      {/* CONTENT */}
      <Box
        {...handlers}
        onClick={() => open && setOpen(false)}
        sx={{
          transform: open ? "translateX(-60px)" : "translateX(0)",
          transition: "transform 0.25s ease",
          backgroundColor: "background.paper",
        }}
      >
        {children}
      </Box>
    </Box>
  );
}
